
<template>

  <svg viewBox="0 2 85.466 73.554" aria-hidden="true">

    <g transform="translate(132.56 -127.12)">

      <path d="m-108.32 129.12c-5.0615 0-8.0215 2.545-9.0196 5.3154l-8.1892 22.73h-1.2583c-2.6081 0-4.5813 2.1026-4.7077 4.7077l-1.0583 21.805c-0.12644 2.6051 2.0995 4.7077 4.7077 4.7077h76.04c2.6082 0 4.8342-2.1026 4.7077-4.7077l-1.0583-21.805c-0.12645-2.6051-2.0996-4.7077-4.7077-4.7077h-1.2583l-8.1892-22.73c-0.99814-2.7705-3.9581-5.3154-9.0196-5.3154h-24.186zm-0.15968 9.2604h37.308l6.9391 18.785h-51.187zm-7.537 27.252c3.507 0 6.35 2.843 6.35 6.35 0 3.507-2.843 6.35-6.35 6.35s-6.35-2.843-6.35-6.35c0-3.507 2.843-6.35 6.35-6.35zm52.382 0c3.507 0 6.35 2.843 6.35 6.35 0 3.507-2.843 6.35-6.35 6.35-3.507 0-6.35-2.843-6.35-6.35 0-3.507 2.843-6.35 6.35-6.35zm-60.32 24.871v6.1035c0 3.3612 2.7061 6.0673 6.0673 6.0673h0.82993c3.3612 0 6.0673-2.7061 6.0673-6.0673v-6.1035zm55.293 0v6.1035c0 3.3612 2.7061 6.0673 6.0673 6.0673h0.82992c3.3612 0 6.0673-2.7061 6.0673-6.0673v-6.1035z"
      
        stroke-width=".25487" fill="currentColor" />
      
    </g>

  </svg>

</template>
